export const in2022 = [
  {
    title: "Barista",
    company: "The Coffee House",
    location: "Hanoi, VN",
    range: "March - July 2022",
    url: "https://thecoffeehouse.com/",
    content: `Grind and brewed over 100 coffee a day, provided a friendly environment and high-quality beverages to customers
    Collaborated with team members to prioritize tasks and efficiently handle peak hours
    Conversed with guests, helping English-speaking customers with drink suggestions, orders, and transactions
    Earned positive comments from customers reviewing the shop through Google Reviews and Store Survey`,
  },
];

export const in2023 = [
  {
    title: "Compliance Officer Intern",
    company: "LianLian Global Vietnam",
    location: "Hanoi, VN",
    range: "April - July 2023",
    url: "https://www.lianlianglobal.com/vn/vi/home",
    content: `Thoroughly reviewed and monitored documents for over 1000 transactions daily for approval, performed anti-money laundering (AML) auditing, and reported suspicious transactions
              Collected and analyzed weekly data using PivotTables on cash-flow trends and the origin of funds to identify potential weaknesses and implemented restrictions to ensure compliance with financial regulations and ethical standards
              Collaborated with cross-functional teams to conduct Know Your Customer (KYC) processes for both individual customers and businesses, ensuring eligibility and a safe environment for existing customers`,
  },
  {
    title: "Business Development Officer Intern",
    company: "LianLian Global Vietnam",
    location: "Hanoi, VN",
    range: "July - September 2023",
    url: "https://www.lianlianglobal.com/vn/vi/home",
    content: `Conducted research on the e-commerce and financial services industry to identify customers’ needs, market trends, and the competitive landscape to ascertain potential market opportunities
              Examined and tested new product features, ensured timely and up-to-standard delivery, and attended to possible errors
               Consulted and established contacts with customers on product features and fees, acquired four high-profile clients`,
  },
];

export const in2024 = [
  {
    title: "Peer Tutor",
    company: "Knack",
    location: "Boston, MA",
    range: "January 2024 - Present",
    url: "https://www.joinknack.com/",
    content: `Conducting one-on-one or group settings tutoring sessions for 9 undergraduate college students in Accounting, Fundamentals to Computer Science, and Discrete Structures, receiving a 5-star rating from student reviews
        Organizing personalized lesson plans to assist students in understanding key concepts, solving problems, and providing guidance on practical applications of theoretical knowledge`,
  },
  {
    title: "Software Developer Intern",
    company: "FPT IS",
    location: "Hanoi, VN",
    range: "July - September 2024",
    url: "https://fpt-is.com/",
    content: `Improved front-end performance of a web application using React.js and implemented new features, achieving a 30% increase in speed by eliminating bugs and reducing code redundancy
              Solved customer requests by optimizing SQL queries within Spring Boot MVC framework, ensuring accurate and efficient data storage and deletion`,
  },
];

export const in2025 = [
  {
    title: "Technology Risk Advisory Intern",
    company: "KPMG US",
    location: "Boston, MA",
    range: "Expected June - August 2025",
    url: "https://kpmg.com/us/en.html",
    content: `To be continue ...`,
  },
];
